import Navbar from "../../components/navbar/navbar.component";
import Sidebar from "../../components/sidebar/sidebar.component";
import { Link, useLocation } from "react-router-dom";

const sidebarLinks = [
  {
    label: "Assets",
    to: "/admin/assets",
  },
  {
    label: "Users",
    to: "/users",
    childLinks: [
      {
        label: "Permissions",
        to: "/admin/user-permissions",
      },
      {
        label: "Roles",
        to: "/admin/user-roles",
      },
    ],
  },
];

const AdminLayout = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <div className={`h-[calc(100vh-72px)] w-full`}>
      <Navbar />
      <Sidebar>
        <div className="flex flex-col p-4 w-content items-center">
          {sidebarLinks.map((link, index) => (
            <div
              key={`${link.label}-${index}`}
              className="flex flex-col w-full justify-start "
            >
              <Link
                className="font-ubuntuBold cursor-pointer hover:underline decoration-primary"
                to={link.to}
              >
                {link.label}
              </Link>
              <ul className="pl-4 flex flex-col">
                {link?.childLinks?.map((childLink, index2) => (
                  <Link
                    key={`${childLink.label}-${index2}`}
                    to={childLink.to}
                    className={`${
                      currentPath?.includes(childLink.to)
                        ? "underline font-bold hover:font-normal"
                        : ""
                    } font-ubuntuRegular cursor-pointer hover:underline decoration-primary`}
                  >
                    {childLink.label}
                  </Link>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Sidebar>
    </div>
  );
};

export default AdminLayout;
